<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen.js';

export default {
  extends: Base,
  data(){
    return {
      Name:"MrFormChecklist",
      PageName: "Checklist List",
      ObjectName: "Checklist",
      WithLimit: true,
      AddItem: true,
      filter: {},
      statusKey: "mfc_is_active",
      checklist: [
        { title: "", items: [
          { title: "", subItems: [ { name: "", duration: 0, responsible: "M", duration_type: "M",  responsible_value: null, using_duration: false, using_remarks: false } ]  }]
        }
      ],
      mrValidation: {
        mfc_name: "required",
        mfc_title: "required",
        mfc_desc: "required",
        mfc_desc_en: "required",
      },

      invalidInput: 0,

      // Options

      responsibleOptions: [
        { label: "R.Manager", value: "M" },
        { label: "Employee", value: "E" },
        { label: "Training Administratior", value: "T" },
      ],

      durationTypeOptions: [
        { label: "Minute", value: "M" },
        { label: "Hour", value: "H" },
        { label: "Day", value: "D" },
        { label: "Week", value: "W" },
        { label: "Month", value: "MH" },
      ],

      mrTrainer: [],

      // -- End Options

      // ID Removed

      idRemovedChecklist: [],
      idRemovedChecklistItem: [],
      idRemovedChecklistSubItem: [],

      // -- END ID Removed
    }
  },
  mounted(){
    this.$set(this.$root, 'page', this)    
    this.refreshData({
      callback: res => {        
        if(res && !res.checklist || this.$route.params.id == 'add') { 
          this.$set(this, 'checklist', [this.templateChecklist])
          this.setMrValidation()
        } else {
          this.setMrValidation()
        }

      }
    })    
  },
  methods: {
    removeMinus(data, e){      
      this.$set(data, 'duration', e < 0 ? 0 : +e.target.value)
    },
    onSubmitForm(e){      
      const newChecklist = this.checklist.map(c => {
        return {
          mfct_title: c.title,
          mfct_id: c.id||0,
          items: c.items.map(item => {
            return {
              mfcst_title: item.title,
              mfcst_id: item.id||0,
              subItems: item.subItems.map(subItem => {
                return {
                  mfci_id: subItem.id||0,                  
                  mfci_name: subItem.name,
                  mfci_name_en: subItem.name_en,
                  mfci_duration: subItem.duration,
                  mfci_duration_type: subItem.duration_type,
                  mfci_using_duration: subItem.using_duration,
                  mfci_using_remarks: subItem.using_remarks||false,
                  mfci_responsible: subItem.responsible,
                  mfci_responsible_value: subItem.responsible_value
                }
              })
            }
          })
        }
      })

      this.$set(this, 'row', {
        ...this.row,
        checklist: JSON.stringify(newChecklist),     
        idRemovedChecklist: this.idRemovedChecklist,
        idRemovedChecklistItem: this.idRemovedChecklistItem,
        idRemovedChecklistSubItem: this.idRemovedChecklistSubItem   
      })

      this.submitForm(e)
    },
    setMrValidation(delay = 1000){
      setTimeout(() => {
        let newValidation = {
          ...this.mrValidation
        }

        // Add Validation Checklist
        this.checklist.map((c,k) => {
          return { [`titleChecklist${k}`] : 'required' }
        }).forEach((c, k) => {
          newValidation = {...newValidation, ...c}
        })

        // Add Validation Rules Item Checklist
        this.checklist.map((c, kChecklist) => {
          return c.items.forEach((item, kItem) => {
            Object.assign(newValidation, { [`titleItem${kChecklist}${kItem}`]: 'required' })
          })
        })

        // Add Validation Rules Sub Item Checklist
        this.checklist.map((c, kChecklist) => {
          return c.items.map((item, kItem) => {
            return item.subItems.forEach((si, kSubItem) => {
              Object.assign(newValidation, { 
                [`subItemName${kChecklist}${kItem}${kSubItem}`]: 'required',
                [`subItemName${kChecklist}${kItem}${kSubItem}_en`]: 'required' 
              })
            })
          })
        })

        this.$set(this, 'mrValidation', newValidation)
    
      }, delay)
    },
    setUsingDuration(data, event){
      this.$set(data, 'using_duration', event.target.checked)
    },
    setUsingRemarks(data, event){
      this.$set(data, 'using_remarks', event.target.checked)
    },
    setDurationType(data, event){      
      this.$set(data, 'durationType', event.target.value)
    },
    setResponsible(data, event){
      if(event.target.value != 'T') this.$set(data, 'responsible_value', null)

      if(event.target.value == 'T' && this.mrTrainer.length > 0) this.$set(data, 'responsible_value', this.mrTrainer[0].id)
      this.$set(data, 'responsible', event.target.value)
    },


    addSubItem(item){
      const data = {...this.templateSubItem}
      item.push(data)

      this.setMrValidation(0)
    },
    addItem(checklist){
      const data = {...this.templateItem, subItems: [{ ...this.templateSubItem }]}
      checklist.push(data)

      this.setMrValidation(0)
    },
    addChecklist(){     
      const data = {...this.templateChecklist, title: "", items: [{...this.templateItem, subItems: [{ ...this.templateSubItem }]}]} 
      this.checklist.push(data)

      this.setMrValidation(0)
    },


    removeChecklistSubItem(data, key, dataSubItem){
      if(data.id && data.id != 0) this.idRemovedChecklistSubItem.push(data.id)
      dataSubItem.splice(key, 1)
    },
    removeChecklistItem(data, key, dataItem){
      if(data.id && data.id != 0) this.idRemovedChecklistItem.push(data.id)
      dataItem.splice(key, 1)
    },
    removeChecklist(data, key, dataChecklist){
      if(data.id && data.id != 0) this.idRemovedChecklist.push(data.id)
      dataChecklist.splice(key, 1)
    },
  },
  watch:{
    '$route.query'(v){
      this.refreshData({
        callback: res => {
          if(res && !res.checklist || this.$route.params.id == 'add') { 
            this.$set(this, 'checklist', [this.templateChecklist])
            this.setMrValidation()
          } else {
            this.setMrValidation()
          }
        }
      })
    },
  },
  computed: {
    templateChecklist(){
      const templateItem = {...this.templateItem}
      return { title: "", items: [templateItem]}
    },
    templateItem(){
      const templateSubItem = {...this.templateSubItem}
      return { title: "", subItems: [templateSubItem] }
    },
    templateSubItem(){
      return { name: "", duration: 0, responsible: "M", duration_type: "M",  responsible_value: null, using_duration: false, using_remarks: false }
    }
  }
}
</script>

<style scoped>
tr.item-centered td
{
  vertical-align:middle;  
  height: 110px;
}
</style>

<template>
  <div class="container-fluid">
    <PageTitle></PageTitle>
    
    <!-- ======================================================================== 
      LIST DATA
    ============================================================================= -->
    <div class="card card-flat" v-if="!$route.params.id">
      <div class="card-body card-filter">
        <VForm @resp="search">
          <div class="row">
            <div class="col-sm-3">
              <h4 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h4>
            </div>
            <div class="col-sm-3">
            </div>
            <div class="col-sm-2">
              <Select2 :options="BoConfig.mrPageLimit" v-model="filter.limit" @input="changeLimit"></Select2>
            </div>
            <div class="col-sm-3">
              <div class="has-feedback has-feedback-left">
                <input type="search" v-model="filter.search" @keyup.enter="search" class="form-control" placeholder="Type and hit Enter">
                <div class="form-control-feedback">
                  <i class="icon-search4 text-size-base text-muted"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-1">
              <button type="button" @click="resetSearch()" class="btn btn-warning btn-sm">Reset</button>
            </div>
          </div>
        </VForm>
      </div>
      <div class="table-responsive ajax-table">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th width="50px">#</th>              
              <th>Checklist Name</th>
              <th>Status</th>
              <th width="120px">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v,k) in data.data" :key="k">
              <td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
              <td>{{v.mfc_name||"-"}}</td>
              <td><StatusLabel :status="v.mfc_is_active?true:false"></StatusLabel></td>
              <td class="btn-action">
                <router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Edit'"><i class="icon-pencil"></i></router-link>
                <a href="javascript:;" class="icon_action" @click="changeStatus(k)" v-tooltip="'Change Status'"><i class="icon-settings"></i></a>
                <a href="javascript:;" class="icon_action" @click="deleteItem($event,k)" v-if="v.showDeleteButton" v-tooltip="'Remove'"><i class="icon-trash"></i></a>
              </td>
            </tr>
            <tr v-if="NotFound">
              <td colspan="99">
                <h3 class="tc">{{NotFound}}</h3>
              </td>
            </tr>
            <tr v-if="data.data===false">
              <td colspan="99">
                <LoadingSpinner light></LoadingSpinner>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-body">
        <div class="pull-right">
          <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
        </div>
      </div>
    </div>

    <!-- ======================================================================== 
      FORM CRUD
    ============================================================================= -->
    <div class="card card-flat" v-if="$route.params.id">
      <VForm @resp="onSubmitForm" method="post">
        <div class="card-body card-form">
          <h4 class="card-title">{{(row.id?"Edit":"Add")+" "+ObjectName}}</h4>
        </div>
        <div class="card-body">
          <div class="info"></div>
          <div class="row">               
            <div class="col-sm-8">
              <BoField name="mfc_name" v-model="row.mfc_name"></BoField> 
            </div>
            <div class="col-sm-8">
              <BoField name="mfc_title" v-model="row.mfc_title"></BoField> 
            </div>
            <div class="col-md-8">
              <bo-field name="desc" label="Form Checklist Description (ID)" mandatory>
                <textarea name="desc" v-model="row.mfc_desc" id="desc" rows="3" class="form-control"
                v-bind="validation('mfc_desc')"></textarea>
              </bo-field>
            </div>
            <div class="col-md-8">
              <bo-field name="desc_en" label="Form Checklist Description (EN)" mandatory>
                <textarea name="desc_en" v-model="row.mfc_desc_en" id="desc_en" rows="3" class="form-control"
                v-bind="validation('mfc_desc_en')"></textarea>
              </bo-field>
            </div>

            <div class="col-md-12 mt-3">
              <h4 class="font-weight-bold">Checklist</h4>

              <div class="table-responsive ajax-table" style="overflow: hidden;">
                <table class="table table-striped table-bordered" v-for="(dataChecklist, kChecklist) in checklist" :key="kChecklist">
                  <thead>
                    <tr>
                      <th colspan="5" style="background:#bde0ff;">
                        <div class="row justify-content-center pt-3 pb-3 position-relative">
                          <div class="col-md-4">
                            <div class="text-center">
                              <BoField :name="`titleChecklist${kChecklist}`" :noLabel="true" :attr="{placeholder: 'cth: 30 Day Goals'}" v-model="dataChecklist.title"></BoField>                              
                            </div>
                          </div>

                          <div class="col-md-12 btn-action" v-if="checklist.length > 1">
                            <a 
                              href="javascript:;" class="text-white bg-danger icon_action" 
                              v-tooltip="'Remove Checklist'"
                              style="position:absolute;right:1em;top:-3.5em;"
                              @click="removeChecklist(dataChecklist, kChecklist, checklist)"
                            >
                              <i class="icon-trash"></i>
                            </a>
                          </div>
                        </div>
                      </th>
                    </tr>

                  </thead>

                  <tbody v-for="(dataItemChecklist, kItemChecklist) in dataChecklist.items" :key="kItemChecklist">
                    <tr style="background:#f2f2f2;">
                      <th style="width: 50%;vertical-align:middle;">
                        <div class="form-group">
                          <label>Item Title</label>
                          <BoField :name="`titleItem${kChecklist}${kItemChecklist}`" :noLabel="true" :attr="{placeholder: 'cth: Administration'}" v-model="dataItemChecklist.title"></BoField>
                          <!-- <input type="text" class="form-control" placeholder="cth: Administration" v-model="dataItemChecklist.title"> -->
                        </div>
                      </th>

                      <th style="width:15%;vertical-align:middle;">
                        <p class="text-center font-weight-bold mb-0">Duration</p>
                      </th>

                      <th style="width:10%;vertical-align:middle;">
                        <p class="text-center font-weight-bold mb-0">Using Remarks?</p>
                      </th>

                      <th style="width:20%;vertical-align:middle;">
                        <p class="text-center font-weight-bold mb-0">Responsible</p>
                      </th>

                      <th style="width:15%;vertical-align:middle;position:relative;">
                        <p class="text-center font-weight-bold mb-0">Action</p>

                        <div 
                          class="row justify-content-center pt-3 pb-3"
                          style="position:absolute;right:0;top:-1em;"
                          v-if="dataChecklist.items.length > 1"
                          @click="removeChecklistItem(dataItemChecklist, kItemChecklist, dataChecklist.items)"
                        >
                          <div class="col-md-12 btn-action">
                            <a 
                              href="javascript:;" class="text-white bg-danger icon_action" 
                              v-tooltip="'Remove Item'"                              
                            >
                              <i class="icon-trash"></i>
                            </a>
                          </div>
                        </div>
                      </th>
                    </tr>

                    <tr v-for="(dataItemSubChecklist, kItemSubChecklist) in dataItemChecklist.subItems" :key="kItemSubChecklist" class="item-centered">
                      <td>
                        <div class="form-group">
                          <label>Item Name</label>
                          <BoField :name="`subItemName${kChecklist}${kItemChecklist}${kItemSubChecklist}`" :noLabel="true" :attr="{placeholder: 'cth: Dapatkan undangan pertemuan yang relevan'}" v-model="dataItemSubChecklist.name"></BoField>

                          <BoField :name="`subItemName${kChecklist}${kItemChecklist}${kItemSubChecklist}_en`" :noLabel="true" :attr="{placeholder: 'ex: Get invitations to relevant meetings'}" v-model="dataItemSubChecklist.name_en"></BoField>
                          <!-- <input type="text" class="form-control" placeholder="cth: Dapatkan undangan pertemuan yang relevan" v-model="dataItemSubChecklist.name"> -->
                        </div>
                      </td>

                      <td>
                        <div class="form-group" style="transform: translateX(1.5em)">
                          <input class="form-check-input" type="checkbox" :id="`duration${kChecklist}${kItemChecklist}${kItemSubChecklist}`" v-model="dataItemSubChecklist.using_duration" @change="setUsingDuration(dataItemSubChecklist, $event)">
                          <label class="form-check-label" :for="`duration${kChecklist}${kItemChecklist}${kItemSubChecklist}`">
                            Using Duration?
                          </label>
                        </div>

                        <div class="input-group mb-3" v-if="dataItemSubChecklist.using_duration">
                          <input type="number" min="0" class="form-control" placeholder="cth: 1" v-model="dataItemSubChecklist.duration" aria-label="Username" aria-describedby="basic-addon1" @input="removeMinus(dataItemSubChecklist, $event)">
                          <div class="input-group-append">
                            <select :id="`duration_type_${kChecklist}${kItemChecklist}${kItemSubChecklist}`" v-model="dataItemSubChecklist.duration_type" class="form-control" @change="setDurationType(dataItemSubChecklist, $event)">                              
                              <option :value="vDurationType.value" v-for="(vDurationType, kDurationType) in durationTypeOptions" :key="kDurationType">{{ vDurationType.label }}</option>
                            </select>
                          </div>
                        </div>

                        <template v-else>
                          <input type="text" class="form-control" disabled value="N/A">
                        </template>
                      </td>

                      <td>
                        <div class="form-group" style="transform: translateX(1.5em)">
                          <input class="form-check-input" type="checkbox" :id="`remarks${kChecklist}${kItemChecklist}${kItemSubChecklist}`" v-model="dataItemSubChecklist.using_remarks" @change="setUsingRemarks(dataItemSubChecklist, $event)">
                          <label class="form-check-label" :for="`remarks${kChecklist}${kItemChecklist}${kItemSubChecklist}`">
                            Using Remarks?
                          </label>
                        </div>
                      </td>
                      
                      <td>
                        <div class="row">
                          <div :class="{'col-md-12': dataItemSubChecklist.responsible != 'T', 'col-md-6': dataItemSubChecklist.responsible == 'T'}">

                            <div class="form-group">
                              <label>Responsible</label>
                              <select :id="`responsible_${kChecklist}${kItemChecklist}${kItemSubChecklist}`" class="form-control" v-model="dataItemSubChecklist.responsible" @change="setResponsible(dataItemSubChecklist, $event)">
                                <option :value="responsible.value" v-for="(responsible, kResponsible) in responsibleOptions" :key="kResponsible">
                                  {{ responsible.label }}
                                </option>
                              </select> 
                            </div>
                          </div>

                          <div class="col-md-6" v-if="dataItemSubChecklist.responsible == 'T'">
                            <div class="form-group">
                              <label>Trainer</label>
                              <select :id="`responsible_value_${kChecklist}${kItemChecklist}${kItemSubChecklist}`" class="form-control" v-model="dataItemSubChecklist.responsible_value">
                                <option :value="trainer.id" v-for="(trainer, kTrainer) in mrTrainer" :key="kTrainer">
                                  {{ trainer.employeename }}
                                </option>
                              </select> 
                            </div>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="row">
                          <div class="col-md-12 btn-action align-items-center h-100 justify-content-center text-center" v-if="dataItemChecklist.subItems.length > 1">
                            <a 
                              href="javascript:;" class="text-white bg-danger icon_action" 
                              v-tooltip="'Remove Sub Item'"
                              @click="removeChecklistSubItem(dataItemSubChecklist, kItemSubChecklist, dataItemChecklist.subItems)"
                            >
                              <i class="icon-trash"></i>
                            </a>
                          </div>

                          <div class="col-md-12" v-else>
                            <span>-</span>
                          </div>
                        </div>
                      </td>
                    </tr>                    

                    <!-- Add Subitem -->
                      <tr>
                        <td colspan="5">
                          <div class="text-center">
                            <a href="javascript:;" @click="addSubItem(dataItemChecklist.subItems)"><i class="fa fa-plus"></i> Add Subitem</a>
                          </div>
                        </td>
                      </tr>
                    <!-- End Add Subitem -->

                    <!-- Add Subitem -->
                      <tr v-if="(kItemChecklist + 1) == dataChecklist.items.length">
                        <td colspan="5">
                          <div class="text-right">
                            <a href="javascript:;" @click="addItem(dataChecklist.items)"><i class="fa fa-plus"></i> Add Item</a>
                          </div>
                        </td>
                      </tr>
                    <!-- End Add Subitem -->
                  </tbody>
                </table>

                <!-- Add Checklist -->
                  <div class="text-right mb-3">
                    <a href="javascript:;" @click="addChecklist"><i class="fa fa-plus"></i> Add Checklist</a>
                  </div>
                <!-- End Add Checklist -->
              </div>
            </div>

            <div class="col-sm-12">
              <div class="text-right">
                <button type="button" @click="back()" class="btn btn-default mr5">Cancel</button>
                <button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit form <i class="icon-arrow-right14 position-right"></i></button>
              </div>
            </div>
          </div>
        </div>
      </VForm>
    </div>
  </div>
</template>
